import React from "react";
import styled from 'styled-components';

const Btn= styled.button`
display: ${props => props.display || "inline-block"};
align-items: flex-start;
text-align:left;
border: none;
background: transparent;
justify-content: center;
text-decoration: underline;
width: ${props => props.width || "auto"};
margin: ${props => props.margin || "auto"};
position: relative;
cursor: pointer;
color: ${props => props.theme.blackST}; 
font-size: 17px;
transition: all .2s ease-out;
padding: 0;
&.small {
    font-size: 15px;
}
  &:hover {
    color: ${props => props.theme.blackST}; 
    text-decoration: underline ${props => props.theme.blackST} 2px;
}

@media screen and (max-width: 576px) {
    width: ${props => props.widthMob || "100%"};
    padding: 15px;
    margin: auto;
}
`;


export default function LienNoirBtnUnderlineST(props) {


    return <Btn onClick={props.onClick} display={props.display} className={props.className} margin={props.margin} width={props.width} widthMob={props.widthMob}>{props.lib}</Btn>   


}